var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c("header-tabs", { attrs: { active: _vm.$route.path } }),
      _vm._v(" "),
      _c("el-row", { staticClass: "filter" }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "80%",
              margin: "0 auto",
              "margin-top": "20px",
              "margin-bottom": "20px"
            }
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.form,
                  "label-width": "200px",
                  "label-width": _vm.formLabelWidth
                }
              },
              [
                _c("p", [_vm._v("快递模版管理")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "菜鸟模版选择:" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "尺寸" },
                        model: {
                          value: _vm.form.size,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "size", $$v)
                          },
                          expression: "form.size"
                        }
                      },
                      _vm._l(_vm.sizeOps, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.name, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [_vm._v("微笑面单配置")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "面单信息需要加密的快递" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "300px" },
                        attrs: { multiple: "", filterable: "" },
                        model: {
                          value: _vm.form.smiling_sender,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "smiling_sender", $$v)
                          },
                          expression: "form.smiling_sender"
                        }
                      },
                      _vm._l(_vm.sendOps, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { value: item.value, label: item.name }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.submit } },
              [_vm._v("保存")]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42415b44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42415b44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/setting/ExpressSize.vue
// module id = null
// module chunks = 